import React, { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { router } from "./app/router/router";
import { store } from "./app/store/store";

const App: React.FC = () => {
    return (
        <Provider store={store}>
            <Suspense fallback={<>loader</>}>
                <RouterProvider router={router} />
            </Suspense>
        </Provider>
    );
};

export default App;
